import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import FloatingWhatsApp from 'react-floating-whatsapp'
import Hero from "components/hero/BackgroundAsImage.js";
import Features from "components/features/DashedBorderSixFeatures";
import MainFeature from "components/features/TwoColSingleFeatureWithStats2.js";
import Testimonial from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
import Battery from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
import Auto from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
import Solar from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
import FAQ from "components/faqs/SimpleWithSideImage.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustration.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import customerSupportIllustrationSrc from "images/customer-support-illustration.svg";
import { HashLink } from 'react-router-hash-link';
import ajay from "images/ajay.jpeg";
import ajayDP from "images/ajayDP.jpeg";
import abhay from "images/abhay.jpeg";
import abhayDP from "images/abhayDP.jpeg";
import abhinav from "images/abhinav.jpeg";
import abhinavDP from "images/abhinavDP.jpeg";
import raghav from "images/raghav.jpeg";
import raghavDP from "images/raghavDP.jpeg";
import team from "images/team.jpeg";
import teamDP from "images/teamDP.jpeg";
import logo from "images/logo.svg";
import white from "images/Solid_white.svg.webp"
import b1 from "images/b1.jpeg";
import b2 from "images/b2.jpeg";
import b3 from "images/b3.jpeg";
import b4 from "images/b4.jpeg";
import b5 from "images/b5.jpeg";
import b6 from "images/b6.jpeg";
import b7 from "images/b7.jpeg";
import b8 from "images/b8.jpeg";
import b9 from "images/b9.jpeg";
import b10 from "images/b10.jpeg";
import s1 from "images/s1.jpg";
import s2 from "images/s2.jpg";
import s3 from "images/s3.jpg";
import s4 from "images/s4.jpg";
import s5 from "images/s5.jpg";
import s6 from "images/s6.jpg";
import s7 from "images/s7.jpg";
import s8 from "images/s8.jpg";
import s9 from "images/s9.jpg";
import a1 from "images/a1.jpg";
import a2 from "images/a2.jpg";
import a3 from "images/a3.jpg";
import a4 from "images/a4.jpg";
import a5 from "images/a5.jpg";
import a6 from "images/a6.jpg";
import a7 from "images/a7.jpg";
import a8 from "images/a8.jpg";
import a9 from "images/a9.jpg";
import a10 from "images/a10.jpg";

export default () => (
  <AnimationRevealPage>
    <Hero />
    <MainFeature />
    <Testimonial
      subheading="Get to know"
      heading={
        <>
          Our Team.<span tw="text-primary-500"></span>
        </>
      }
      description="Here is the core team that makes Jasoria Brothers what it is today. Each member of the team is committed to their expertise and gives their 100% to make every client a happy customer."
      testimonials={[
        {
          imageSrc:
            ajay,
          profileImageSrc:
            ajayDP,
          quote:
            "Mr. Ajay Jasoria is an authentic and honest retail dealer of spare part products in the city of Bareilly, since 1963. The main aim of Mr. Jasoria is to attract coustomer with his genuinity and giving them the best experience with the vision of expansion. His works have made him achieve plenty of awards from companies like Tata Motors, Maruti genuine parts, and Hyundai genuine parts.",
          customerName: "Ajay Jasoria",
        },
        {
          imageSrc:
            abhay,
          profileImageSrc:
            abhayDP,
          quote:
            "Mr. Abhay Jasoria has always been a strong stem of Jasoria Brothers, first helped his dad then took the business forward and brought it up to this level. He is an expert in the field of alternative Power solutions. He has launched a battery by the brand Invo Power and JM Tick. Mr. Jasoria has a great network of more than 200 dealers. Mr. Abhay sees himself working at PAN India level in coming years.",
          customerName: "Abhay Jasoria",
        },
        {
          imageSrc:
            abhinav,
          profileImageSrc:
            abhinavDP,
          quote:
            "Mr. Abhinav Jasoria is a polite and courteous part of Jasoria Brother. He studied Marketing from G.D. Goenka, Delhi. His great skills in marketing have made Jasoria Brothers one of the best dealers in U.P. Mr.Abhinav sees after all the Maruti genuine parts, Hyundai genuine parts, Tata genuine parts , General motor genuine parts , Minda , Roots and Government tenders of solar energy in the firm.",
          customerName: "Abhinav Jasoria",
        },
        {
          imageSrc:
            raghav,
          profileImageSrc:
            raghavDP,
          quote:
            "Mr. Raghav Jasoria is a young witty man studied finance from Amity, Noida. With his astounding work and brain working like tornado in business he has made a significant impact in Jasoria Brothers. After earning the confidence from his family members he is now working upon the expansion of business by bringing more services. His youthful way of dealing has an aim of diversifying Jasoria Brother.",
          customerName: "Raghav Jasoria",
        },
        {
          imageSrc:
            team,
          profileImageSrc:
            teamDP,
          quote:
            "Our team is clear on its goals, and each member takes pride in working at a place like Jasoria Brothers. Every employee at Jasoria Brothers is like a family member to the management. Workers are generously paid and their assignments are well recognised. The management helps in all possible ways to help individuals and the company accomplish their goals.",
          customerName: "Other Team Members",
          customerTitle: "Soul of our Team",
        }
      ]}
      textOnLeft={true}
    />
    <Features />
    <Battery
      subheading="Information about"
      heading={
        <>
          Batteries<span tw="text-primary-500"> & </span>Inverters
        </>
      }
      description="Jasoria Brothers are leading Battery and Inverter dealership in Bareilly. We have been working in this field and have mastered the art over the past few decades."
      testimonials={[
        {
          imageSrc:
            b1,
          profileImageSrc:
           white,
          quote:
            "We deal in almost all kinds of batteries and inverters. Some of the companies we deal with are: SF Sonic, Invo Power, JMTick, Bluebird, etc. Use the link below to get in touch and we will try our best to help you.",
          customerName: "",
        },
        {
          imageSrc:
            b2,
          profileImageSrc:
          white,
          quote:
            "We deal in almost all kinds of batteries and inverters. Some of the companies we deal with are: SF Sonic, Invo Power, JMTick, Bluebird, etc. Use the link below to get in touch and we will try our best to help you.",
            customerName: "",
          },
        {
          imageSrc:
            b3,
          profileImageSrc:
          white,
          quote:
            "We deal in almost all kinds of batteries and inverters. Some of the companies we deal with are: SF Sonic, Invo Power, JMTick, Bluebird, etc. Use the link below to get in touch and we will try our best to help you.",
            customerName: "",
          },
        {
          imageSrc:
            b4,
          profileImageSrc:
          white,
          quote:
            "We deal in almost all kinds of batteries and inverters. Some of the companies we deal with are: SF Sonic, Invo Power, JMTick, Bluebird, etc. Use the link below to get in touch and we will try our best to help you.",
            customerName: "",
          },
        {
          imageSrc:
            b5,
          profileImageSrc:
          white,
          quote:
            "We deal in almost all kinds of batteries and inverters. Some of the companies we deal with are: SF Sonic, Invo Power, JMTick, Bluebird, etc. Use the link below to get in touch and we will try our best to help you.",
            customerName: "",
          },
        {
          imageSrc:
            b6,
          profileImageSrc:
          white,
          quote:
            "We deal in almost all kinds of batteries and inverters. Some of the companies we deal with are: SF Sonic, Invo Power, JMTick, Bluebird, etc. Use the link below to get in touch and we will try our best to help you.",
            customerName: "",
          },
        {
          imageSrc:
            b7,
          profileImageSrc:
          white,
          quote:
            "We deal in almost all kinds of batteries and inverters. Some of the companies we deal with are: SF Sonic, Invo Power, JMTick, Bluebird, etc. Use the link below to get in touch and we will try our best to help you.",
            customerName: "",
          },
        {
          imageSrc:
            b8,
          profileImageSrc:
           logo,
          quote:
            "We deal in almost all kinds of batteries and inverters. Some of the companies we deal with are: SF Sonic, Invo Power, JMTick, Bluebird, etc. Use the link below to get in touch and we will try our best to help you.",
            customerName: "",
          },
        {
          imageSrc:
            b9,
          profileImageSrc:
          white,
          quote:
            "We deal in almost all kinds of batteries and inverters. Some of the companies we deal with are: SF Sonic, Invo Power, JMTick, Bluebird, etc. Use the link below to get in touch and we will try our best to help you.",
            customerName: "",
          },
        {
          imageSrc:
            b10,
          profileImageSrc:
          white,
          quote:
            "We deal in almost all kinds of batteries and inverters. Some of the companies we deal with are: SF Sonic, Invo Power, JMTick, Bluebird, etc. Use the contact us link to get in touch and we will try our best to help you.",
            customerName: "",
          }

      ]}
      textOnLeft={true}
    />
    <Auto
      subheading="Information About"
      heading={
        <>
          Auto Parts<span tw="text-primary-500"> & </span>Accessories
        </>
      }
      description="Located in the heart of Bareilly's Auto Part Market, we at Jasoria brothers sell all leading auto parts and lubricants of all leading brands including Maruti, Hyundai, Kia and Toyota."
      testimonials={[
        {
          imageSrc:
            a1,
          profileImageSrc:
            white,
          quote:
            "We spend all our lifelong incomes to get a car of our dream. It is only justified to spend money and take care of our automobiles. Get in touch to get best advice and service for your amazing automobiles.",
          customerName: "",
        },
        {
          imageSrc:
            a2,
          profileImageSrc:
            white,
          quote:
            "We spend all our lifelong incomes to get a car of our dream. It is only justified to spend money and take care of our automobiles. Get in touch to get best advice and service for your amazing automobiles.",
          customerName: "",
        },
        {
          imageSrc:
            a3,
          profileImageSrc:
            white,
          quote:
            "We spend all our lifelong incomes to get a car of our dream. It is only justified to spend money and take care of our automobiles. Get in touch to get best advice and service for your amazing automobiles.",
          customerName: "",
        },
        {
          imageSrc:
            a4,
          profileImageSrc:
            white,
          quote:
            "We spend all our lifelong incomes to get a car of our dream. It is only justified to spend money and take care of our automobiles. Get in touch to get best advice and service for your amazing automobiles.",
          customerName: "",
        },
        {
          imageSrc:
            a5,
          profileImageSrc:
            white,
          quote:
            "We spend all our lifelong incomes to get a car of our dream. It is only justified to spend money and take care of our automobiles. Get in touch to get best advice and service for your amazing automobiles.",
          customerName: "",
        },
        {
          imageSrc:
            a6,
          profileImageSrc:
            white,
          quote:
            "We spend all our lifelong incomes to get a car of our dream. It is only justified to spend money and take care of our automobiles. Get in touch to get best advice and service for your amazing automobiles.",
          customerName: "",
        },
        {
          imageSrc:
            a7,
          profileImageSrc:
            white,
          quote:
            "We spend all our lifelong incomes to get a car of our dream. It is only justified to spend money and take care of our automobiles. Get in touch to get best advice and service for your amazing automobiles.",
          customerName: "",
        },
        {
          imageSrc:
            a8,
          profileImageSrc:
            white,
          quote:
            "We spend all our lifelong incomes to get a car of our dream. It is only justified to spend money and take care of our automobiles. Get in touch to get best advice and service for your amazing automobiles.",
          customerName: "",
        },
        {
          imageSrc:
            a9,
          profileImageSrc:
            white,
          quote:
            "We spend all our lifelong incomes to get a car of our dream. It is only justified to spend money and take care of our automobiles. Get in touch to get best advice and service for your amazing automobiles.",
          customerName: "",
        },
        {
          imageSrc:
            a10,
          profileImageSrc:
            white,
          quote:
            "We spend all our lifelong incomes to get a car of our dream. It is only justified to spend money and take care of our automobiles. Get in touch to get best advice and service for your amazing automobiles.",
          customerName: "",
        },
        
      ]}
      textOnLeft={true}
    />
    <Solar
      subheading="Information About"
      heading={
        <>
          Solar<span tw="text-primary-500"> & </span>Renewable Energy
        </>
      }
      description="As the world is moving towards sustainable future, we at Jasoria Brothers are trying to make Bareilly - SMARTER, CLEANER and GREENER by providing Solar energy."
      testimonials={[
        {
          imageSrc:
            s1,
          profileImageSrc:
            white,
          quote:
          "We deal in various kinds of solar panels and renewable energy accessories. Some of the companies we deal with are: Smarten, UTL Solar, Bluebird, etc. Use the contact us link to get in touch and we will try our best to help you.",
          customerName: "",
        },
        {
          imageSrc:
            s2,
          profileImageSrc:
            white,
          quote:
          "We deal in various kinds of solar panels and renewable energy accessories. Some of the companies we deal with are: Smarten, UTL Solar, Bluebird, etc. Use the contact us link to get in touch and we will try our best to help you.",
          customerName: "",
        },
        {
          imageSrc:
            s3,
          profileImageSrc:
            white,
          quote:
          "We deal in various kinds of solar panels and renewable energy accessories. Some of the companies we deal with are: Smarten, UTL Solar, Bluebird, etc. Use the contact us link to get in touch and we will try our best to help you.",
          customerName: "",
        },
        {
          imageSrc:
            s4,
          profileImageSrc:
            white,
          quote:
          "We deal in various kinds of solar panels and renewable energy accessories. Some of the companies we deal with are: Smarten, UTL Solar, Bluebird, etc. Use the contact us link to get in touch and we will try our best to help you.",
          customerName: "",
        },
        {
          imageSrc:
            s5,
          profileImageSrc:
            white,
          quote:
          "We deal in various kinds of solar panels and renewable energy accessories. Some of the companies we deal with are: Smarten, UTL Solar, Bluebird, etc. Use the contact us link to get in touch and we will try our best to help you.",
          customerName: "",
        },
        {
          imageSrc:
            s6,
          profileImageSrc:
            white,
          quote:
          "We deal in various kinds of solar panels and renewable energy accessories. Some of the companies we deal with are: Smarten, UTL Solar, Bluebird, etc. Use the contact us link to get in touch and we will try our best to help you.",
          customerName: "",
        },
        {
          imageSrc:
            s7,
          profileImageSrc:
            white,
          quote:
          "We deal in various kinds of solar panels and renewable energy accessories. Some of the companies we deal with are: Smarten, UTL Solar, Bluebird, etc. Use the contact us link to get in touch and we will try our best to help you.",
          customerName: "",
        },
        {
          imageSrc:
            s8,
          profileImageSrc:
            white,
          quote:
          "We deal in various kinds of solar panels and renewable energy accessories. Some of the companies we deal with are: Smarten, UTL Solar, Bluebird, etc. Use the contact us link to get in touch and we will try our best to help you.",
          customerName: "",
        },
        {
          imageSrc:
            s9,
          profileImageSrc:
            white,
          quote:
          "We deal in various kinds of solar panels and renewable energy accessories. Some of the companies we deal with are: Smarten, UTL Solar, Bluebird, etc. Use the contact us link to get in touch and we will try our best to help you.",
          customerName: "",
        },
        {
          imageSrc:
            b10,
          profileImageSrc:
            white,
          quote:
          "We deal in various kinds of solar panels and renewable energy accessories. Some of the companies we deal with are: Smarten, UTL Solar, Bluebird, etc. Use the contact us link to get in touch and we will try our best to help you.",
          customerName: "",
        },
      ]}
      textOnLeft={true}
    />
    <FAQ
      imageSrc={customerSupportIllustrationSrc}
      imageContain={true}
      imageShadow={false}
      subheading="FAQs"
      heading={
        <>
          Do you have <span tw="text-primary-500">Questions ?</span>
        </>
      }
    />
    <ContactUsForm />
    <Footer />
    <FloatingWhatsApp
        phoneNumber="917830000313"
        accountName="Jasoria Brothers"
        allowClickAway
      />
  </AnimationRevealPage>
);
